import { APP_ROUTES } from "../constants";
import { useCallbackUrl } from "../store/usePartnerStore";
import { useSessionStore } from "../store/useSessionStore";
import { useRouteWithToken } from "./useRouteWithToken";

const isValidHttpUrl = (url: string): boolean =>
  url.startsWith("http://") || url.startsWith("https://");

/**
 * Exit helpers for leaving the widget:
 * - Prefer link `config.callbackUrl`, then partner `sessionExpiredRedirectUrl`.
 * - `canExitToPartner` lets hubs hide a duplicate "Back home" when there is no
 *   external destination (navbar Back already returns to Landing).
 * - `exitToPartnerOrLanding` still falls back to Landing for error screens.
 */
export const useExitToPartnerOrLanding = () => {
  const sessionExpiredUrl = useCallbackUrl();
  const linkCallbackUrl = useSessionStore((s) => s.session.data?.config?.callbackUrl);
  const { redirectTo } = useRouteWithToken();

  const partnerExitUrl =
    [linkCallbackUrl, sessionExpiredUrl].find(
      (url): url is string => Boolean(url && isValidHttpUrl(url))
    ) ?? null;

  const canExitToPartner = Boolean(partnerExitUrl);

  const exitToPartnerOrLanding = () => {
    if (partnerExitUrl) {
      window.location.href = partnerExitUrl;
      return;
    }
    redirectTo(APP_ROUTES.LANDING_PAGE);
  };

  return { exitToPartnerOrLanding, canExitToPartner, partnerExitUrl };
};
